export { default } from './DtrMultiLogs.js';